import { render, staticRenderFns } from "./main_view.vue?vue&type=template&id=41442773&scoped=true"
var script = {}
import style0 from "./main_view.vue?vue&type=style&index=0&id=41442773&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41442773",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41442773')) {
      api.createRecord('41442773', component.options)
    } else {
      api.reload('41442773', component.options)
    }
    module.hot.accept("./main_view.vue?vue&type=template&id=41442773&scoped=true", function () {
      api.rerender('41442773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/main_view/main_view.vue"
export default component.exports